// Builds each carrier's own public tracking-page URL with the tracking
// number pre-filled, for the exact carrier list TrackingForm's <select>
// offers (see OrderDetailsPage.jsx's CARRIERS). Kept as one small lookup
// here rather than duplicated wherever a tracking link is shown (currently
// the fulfillment card and the Conversion Summary card on Order Details).
//
// A couple of these (India Post in particular) don't have a documented
// GET-param prefill on their official tracking page — those just link to
// the carrier's base tracking page instead of a dead/wrong deep link,
// which is why "prefilled where supported" is the promise, not "prefilled
// always". "Other" has no entry at all — see getTrackingUrl below.
const CARRIER_TRACKING_URL_BUILDERS = {
  Delhivery: (awb) => `https://www.delhivery.com/track-v2/package/${awb}`,
  BlueDart: (awb) => `https://www.bluedart.com/tracking?trackFor=0&trackNo=${awb}`,
  FedEx: (awb) => `https://www.fedex.com/fedextrack/?trknbr=${awb}`,
  DTDC: (awb) => `https://www.dtdc.in/tracking/tracking_results.asp?strCnno=${awb}&Submit=Submit`,
  Ekart: (awb) => `https://ekartlogistics.com/track/${awb}`,
  Xpressbees: (awb) => `https://www.xpressbees.com/track?awb=${awb}`,
  Shadowfax: (awb) => `https://track.shadowfax.in/#/track/${awb}`,
  "Ecom Express": (awb) => `https://ecomexpress.in/tracking/?awb_field=${awb}`,
  DHL: (awb) => `https://www.dhl.com/in-en/home/tracking/tracking-express.html?submit=1&tracking-id=${awb}`,
  Shiprocket: (awb) => `https://shiprocket.co/tracking/${awb}`,
  // No reliable GET-param prefill on India Post's official (ASP.NET
  // postback-based) tracking page — link to the page itself.
  "India Post": () => "https://www.indiapost.gov.in/_layouts/15/dop.portal.tracking/trackconsignment.aspx",
  // "Other" intentionally has no entry — a seller-typed carrier name has no
  // known tracking-page format, so no link is offered for it.
};

/** Returns the carrier's tracking URL for this AWB, or null if the carrier
 * isn't recognized or there's no tracking number to build one from. */
export function getTrackingUrl(carrier, trackingNumber) {
  const awb = trackingNumber?.trim();
  if (!awb) return null;
  const build = CARRIER_TRACKING_URL_BUILDERS[carrier];
  return build ? build(encodeURIComponent(awb)) : null;
}
